<int-integrators-details
        [integrationName]="integrationName"
        [integrationType]="integrationType"
        [creating]="creating"
        [user]="user"
        [invites]="invites"></int-integrators-details>

<div class="content" mat-dialog-content>
  <div *ngIf="creating" class="int-text-container">
    {{description}}
  </div>

  <mat-spinner *ngIf="loading"></mat-spinner>
  <div *ngIf="creating && accounts && !loading">
    <mat-form-field>
      <mat-select placeholder="Select an Ad Account" [(ngModel)]="adAccount">
        <mat-option *ngFor="let account of accounts" [value]="account.id">
          {{ account.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="isAdmin && invites && invites.length > 0">
    <button mat-stroked-button color="primary" (click)="onViewInvitesClick()">VIEW ALL INVITES</button>
  </div>

  <div *ngIf="!creating" fxLayout="row" fxLayoutAlign="start center" class="int-add-container">
    <button mat-stroked-button color="primary" (click)="addAnother($event)">
      <mat-icon>add</mat-icon>
      <span class="center-text">ADD ANOTHER ACCOUNT</span>
    </button>
  </div>

  <div *ngIf="!noAccounts && !creating">
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="!showAccounts">
      <mat-icon>expand_more</mat-icon>
      <span>SHOW CONNECTED ACCOUNTS</span>
    </button>
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="showAccounts">
      <mat-icon>expand_less</mat-icon>
      <span>HIDE CONNECTED ACCOUNTS</span>
    </button>
  </div>

  <div *ngIf="!creating" [hidden]="!showAccounts">
    <h4 *ngIf="existingIntegrations.length > 0" class="mr-4">Connected Accounts</h4>
    <div *ngFor="let int of existingIntegrations">Account Name: {{ int.friendlyName }}</div>
  </div>
</div>

<div fxLayout="row" fxLayoutAlign="center">
  <button class="twitter-button" *ngIf="creating && !accounts && !loading" mat-button (click)="login($event)">
    <i class="fab fa-twitter"></i> Sign in with Twitter
  </button>
</div>

<div mat-dialog-actions align="end">
  <div fxLayout="row" fxLayoutAlign="end end">
    <button mat-button mat-dialog-close>CANCEL</button>
    <button [disabled]="!adAccount" *ngIf="creating" mat-raised-button (click)="addAccount($event)" color="primary">
      SAVE
    </button>
  </div>
</div>
